module.exports = __webpack_public_path__ + "assets/images/b6b6ec92812db7e26306e0bbbc31e014.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/lazard-logo.svg
// module id = 828
// module chunks = 0